// Copied from https://github.com/facebook/lexical/blob/main/packages/lexical-playground/src/ui/KatexRenderer.tsx
import katex from 'katex';
import { useEffect, useRef } from 'react';

interface KatexRendererProps {
  equation: string;
  inline?: boolean;
  onDoubleClick?: () => void;
}

function KatexRenderer(props: Readonly<KatexRendererProps>) {
  const { equation, inline: isInline = true, onDoubleClick } = props;
  const katexElementRef = useRef(null);

  useEffect(() => {
    const katexElement = katexElementRef.current;

    if (katexElement !== null) {
      katex.render(equation, katexElement, {
        displayMode: !isInline, // true === block display
        errorColor: '#cc0000',
        output: 'html',
        strict: 'warn',
        throwOnError: false,
        trust: false,
      });
    }
  }, [equation, isInline]);

  return (
    // We use an empty image tag either side to ensure Android doesn't try and compose from the
    // inner text from Katex. There didn't seem to be any other way of making this work,
    // without having a physical space.
    <>
      <img src='#' alt='' />
      <span role='button' tabIndex={-1} onDoubleClick={onDoubleClick} ref={katexElementRef} />
      <img src='#' alt='' />
    </>
  );
}

export { KatexRenderer };
export type { KatexRendererProps };
